var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.navigationStack.length || _vm.selectedFolder
    ? _c(
        "v-breadcrumbs",
        { staticClass: "pa-0 d-flex align-center" },
        [
          _c(
            "v-breadcrumbs-item",
            {
              staticClass: "breadcrumb-link px-1",
              on: { click: _vm.resetNavigation },
            },
            [_vm._v("Inicio")]
          ),
          _vm._l(_vm.navigationStack, function (folder, index) {
            return _c(
              "div",
              { key: index },
              [
                _c("span", { staticClass: "divider-bread" }, [_vm._v("·")]),
                _c(
                  "v-breadcrumbs-item",
                  {
                    staticClass: "breadcrumb-link px-1",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.goToFolder(index)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(folder.name) + " ")]
                ),
              ],
              1
            )
          }),
          _vm.selectedFolder
            ? _c(
                "div",
                [
                  _c("span", { staticClass: "divider-bread" }, [_vm._v("·")]),
                  _c(
                    "v-breadcrumbs-item",
                    { staticClass: "px-1", attrs: { disabled: "" } },
                    [_vm._v(_vm._s(_vm.selectedFolder.name))]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }